import { defineMessages } from 'react-intl';

export const scope = 'app.component.base.checkbox';

export default defineMessages({
  checkbox_checked: {
    id: `${scope}.checkbox_checked`,
    defaultMessage: 'Checkbox checked',
  },
  checkbox_unchecked: {
    id: `${scope}.checkbox_unchecked`,
    defaultMessage: 'Checkbox unchecked',
  },
});
